import React, { useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

const NAV_GROUPS = [
  {
    label: "Principal",
    links: [
      {
        to: "/", exact: true, label: "Dashboard",
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>,
      },
      {
        to: "/restaurants/new", exact: false, label: "Adaugă restaurant",
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
      },
    ],
  },
  {
    label: "Clienți",
    links: [
      {
        to: "/client-accounts", exact: false, label: "Conturi clienți",
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
      },
      {
        to: "/tickets", exact: false, label: "Tickete suport",
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
      },
    ],
  },
  {
    label: "Sistem",
    links: [
      {
        to: "/update-notes", exact: false, label: "Noutăți",
        icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
      },
    ],
  },
];

export default function Sidebar({ open, onClose, stats = {} }) {
  const location = useLocation();

  useEffect(() => { onClose?.(); }, [location.pathname]);

  const logout = () => {
    localStorage.removeItem("hubToken");
    window.location.href = "/login";
  };

  const badges = {
    "/tickets":         stats.openTickets     > 0 ? stats.openTickets     : null,
    "/client-accounts": stats.pendingAccounts > 0 ? stats.pendingAccounts : null,
  };

  return (
    <aside id="hub-sidebar" className={open ? "open" : ""}>
      <style>{`
        #hub-sidebar { background: #fff !important; border-right: 1.5px solid #e8edf3; }
      `}</style>

      {/* Logo */}
      <div style={{ padding: "24px 20px 20px", borderBottom: "1.5px solid #e8edf3" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 38, height: 38, borderRadius: 11, background: "linear-gradient(135deg,#4f46e5,#7c3aed)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 4px 12px rgba(99,102,241,0.35)" }}>
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </div>
          <div>
            <div style={{ fontWeight: 900, fontSize: 17, color: "#111827", lineHeight: 1.1, letterSpacing: "-0.3px" }}>Orderly</div>
            <div style={{ fontSize: 10, fontWeight: 800, color: "#6366f1", letterSpacing: "2px", textTransform: "uppercase", marginTop: 1 }}>HUB</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: "16px 12px", display: "flex", flexDirection: "column", gap: 24, overflowY: "auto" }}>
        {NAV_GROUPS.map(group => (
          <div key={group.label}>
            <p style={{ fontSize: 10, fontWeight: 800, color: "#b0bac9", textTransform: "uppercase", letterSpacing: "1px", padding: "0 10px 8px", margin: 0 }}>
              {group.label}
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {group.links.map(link => (
                <NavLink key={link.to} to={link.to} end={link.exact}
                  style={({ isActive }) => ({
                    display: "flex", alignItems: "center", gap: 12,
                    padding: "11px 12px", borderRadius: 10,
                    textDecoration: "none",
                    fontSize: 14, fontWeight: 600,
                    color: isActive ? "#4f46e5" : "#4b5563",
                    background: isActive ? "#eef2ff" : "transparent",
                    transition: "all .15s",
                    position: "relative",
                  })}
                  onMouseEnter={e => {
                    if (!e.currentTarget.style.background.includes("eef2ff"))
                      e.currentTarget.style.background = "#f5f7ff";
                  }}
                  onMouseLeave={e => {
                    if (!e.currentTarget.style.background.includes("eef2ff"))
                      e.currentTarget.style.background = "transparent";
                  }}
                >
                  {({ isActive }) => (
                    <>
                      <span style={{ color: isActive ? "#4f46e5" : "#9ca3af", flexShrink: 0 }}>{link.icon}</span>
                      <span style={{ flex: 1 }}>{link.label}</span>
                      {badges[link.to] && (
                        <span style={{ background: "#ef4444", color: "white", fontSize: 10, fontWeight: 800, padding: "2px 7px", borderRadius: 100, minWidth: 20, textAlign: "center" }}>
                          {badges[link.to]}
                        </span>
                      )}
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div style={{ padding: "14px 12px 22px", borderTop: "1.5px solid #e8edf3" }}>
        <button onClick={logout}
          style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "11px 12px", borderRadius: 10, border: "none", background: "transparent", color: "#9ca3af", fontSize: 14, fontWeight: 600, cursor: "pointer", transition: "all .15s" }}
          onMouseEnter={e => { e.currentTarget.style.background = "#fef2f2"; e.currentTarget.style.color = "#ef4444"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#9ca3af"; }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Deconectare
        </button>
      </div>
    </aside>
  );
}

export function MobileTopbar({ onOpen }) {
  return (
    <div id="hub-topbar" style={{ background: "#fff", borderBottom: "1.5px solid #e8edf3" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 30, height: 30, borderRadius: 9, background: "linear-gradient(135deg,#4f46e5,#7c3aed)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </div>
        <span style={{ fontWeight: 900, fontSize: 16, color: "#111827", letterSpacing: "-0.3px" }}>
          Orderly <span style={{ color: "#6366f1" }}>Hub</span>
        </span>
      </div>
      <button onClick={onOpen}
        style={{ background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6"/>
          <line x1="3" y1="12" x2="21" y2="12"/>
          <line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
      </button>
    </div>
  );
}

export function SidebarOverlay({ show, onClose }) {
  return <div id="hub-overlay" className={show ? "show" : ""} onClick={onClose} />;
}
